/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useRef, useEffect, useCallback } from "react"
import {
  GlobalStyle,
  AppContainer,
  Error,
  Notification,
  useNotification,
  Main,
  Header,
  useSocketMessages,
  createSocket,
  useHistory,
  useBlurAndAbove,
  Protocol,
  objToStringSettings,
  Loading,
  useLoading,
  stakeChecker,
  useGlobalAudio,
  settingsStringParsing,
  SetStakeModalPage,
  useModal,
  // BackLayer,
  addMouseFlow,
} from "@orbitalgaming/games-frontend-library"
import { MessagesList } from "lib/messages"
import { colors } from "lib/colors"
import { usePage } from "./usePage"
import Baccarat from "components/Baccarat"
import useSound from "use-sound"
import backgroundSFX from "lib/audio/sounds/background.mp3"
import useCustomAudio from "lib/audio/useCustomAudios"
import useBalanceUpdate from "functions/useBalanceUpdate"

const App = () => {
  const name = "baccarat"
  const WS_URL = "{{SERVER_WS_URL}}"
  const wsbridge = "websocketbridge/ws"

  const isZero = true
  const enableLoading = false
  const balanceUpdateOn = "now"
  const clickable = true
  const betInfoBox = true
  const socket = useRef<any>(null)

  const expectedSettings = [
    { name: "stake", minStake: "0.00", maxStake: "100000000000.00" },
    { name: "stake", minStake: "0.00", maxStake: "100000000000.00" },
    { name: "stake", minStake: "0.00", maxStake: "100000000000.00" },
    { name: "music" },
    { name: "sound" },
    { name: "volume" },
  ]
  const sendingSettings = [
    { name: "stake", minStake: "0.00", maxStake: "100000000000.00" },
    { name: "music" },
    { name: "sound" },
    { name: "volume" },
  ]

  const [gameInfo, setgameInfo] = useState({
    user_name: "",
    user_id: "",
    currency: "",
    balance: "",
    precision: 2,
    maxBet: "",
    minBet: "",
  })
  const [betInfo, setbetInfo] = useState({
    balance: "",
    balance_before: "",
    bet_id: "",
    winAmount: "",
    betAmount: "",
    banker: { cards: [] },
    player: { cards: [] },
  })

  const [seeds, setSeeds] = useState({
    client_seed: "",
    server_seed_SHA256: "",
    next_server_seed_SHA256: "",
    nonce: 0,
    old_client_seed: "",
    old_servr_seed: "",
    old_erver_seed_SHA256: "",
    old_nonce: 0,
  })
  const [audio, setaudio] = useState({
    music: true,
    sound: true,
    volume: "0.5",
  })

  const [betReply, setBetReply] = useState({})

  const [bankerStake, setBankerStake] = useState("0.00")
  const [tieStake, setTieStake] = useState("0.00")
  const [playerStake, setplayerStake] = useState("0.00")
  const [stake, setstake] = useState(0)
  const [totalStakeAmount, setTotalStakeAmount] = useState(0)
  const [currentStake, setCurrentStake] = useState("")
  const [currentName, setCurrentName] = useState("")
  const [errorText, seterrorText] = useState<string | boolean>(false)
  const [isLoaded, setisLoaded] = useState(false)
  const [roundId, setRoundId] = useState<string>("")

  const [errorCode, setErrorCode] = useState<number>(0)
  const [isError, setIsError] = useState<boolean>(false)

  useEffect(() => {
    switch (errorCode) {
      case 3:
      case 4:
      case 6:
      case 11:
      case 16:
      case 115:
        setIsError(true)
        setErrorCode(0)
        break

      default:
        setIsError(false)
        break
    }
  }, [errorCode])

  const { user_id, maxBet, minBet, balance, precision } = gameInfo
  const [history, addInHistory] = useHistory(user_id)

  // const fixedTotalStake = totalStakeAmount.toFixed(2)

  useEffect(() => {
    setstake(+playerStake + +tieStake + +bankerStake)
  }, [playerStake, tieStake, bankerStake, stake])

  useEffect(() => addMouseFlow(), [])

  const handleStake = (s: string) => {
    // setstake(s)
    setCurrentStake(s)
    if (currentName.includes("player")) {
      setplayerStake(s)
    } else if (currentName.includes("tie")) {
      setTieStake(s)
    } else if (currentName.includes("banker")) {
      setBankerStake(s)
    }
  }
  const handlePlayerStake = (s: string) => setplayerStake(s)

  const handleBankerStake = (s: string) => setBankerStake(s)

  const handleTieStake = (s: string) => setTieStake(s)

  const handleCurrentStake = (s: string) => setCurrentStake(s)

  const handleCurrentName = (name: string) => setCurrentName(name)

  const handleFinalStake = (p: string, b: string, t: string) => {
    const sum = +p + +b + +t
    setTotalStakeAmount(sum)
  }

  const handleAudio = (s: any) => {
    setaudio(s)
    sendSettings([bankerStake, tieStake, playerStake], s)
  }

  const seedRequest = () => {
    sendSocketMessage(Protocol.GET_SEEDS)
  }
  const newSeedRequest = (s: string) => {
    sendSocketMessage(Protocol.SET_SEED, s)
  }
  const verifierFunc = () => {
    window.open("https://codepen.io/orbitalgaming/pen/WNmxdRR", "_blank")
  }

  const receiveSettings = (str: string) => {
    const [bankerStake, tieStake, playerStake, music, sound, volume] =
      settingsStringParsing(str, expectedSettings)
    setBankerStake(bankerStake)
    setTieStake(tieStake)
    setplayerStake(playerStake)
    setaudio({
      music,
      sound,
      volume,
    })
  }
  const sendSettings = (
    stakeFromSettings: string[],
    audioFromSettings: any,
  ) => {
    const sendstake = stakeFromSettings ? stakeFromSettings : stake
    const sendaudio = audioFromSettings ? audioFromSettings : audio
    const stringified = objToStringSettings(
      {
        stake: sendstake,
        minStake: minBet,
        maxStake: maxBet,
        sound: sendaudio.sound,
        music: sendaudio.music,
        volume: sendaudio.volume,
      },
      sendingSettings,
    )
    sendSocketMessage(Protocol.USER_SETTINGS_POST, stringified)
  }

  const handleErrorText = (text: string) => {
    seterrorText(errorText => (errorText ? errorText : text))
  }

  const [notification, handleNotification, notificationfadeOut] =
    useNotification()

  const [blur, unBlur, settingsUnblur, above, handleAbove] = useBlurAndAbove()
  const { fadeIn, fadeOut, modal, handleModal } = useModal()

  //remove usepagae
  const [Page] = usePage({ clickable, precision, colors, handleAbove, audio })

  const pages = [
    "settings",
    "Game Rules",
    "Provably Fair",
    "History",
    "SetStake",
  ]
  const loadedPages = enableLoading ? [] : pages

  const [arePagesLoaded, duration] = useLoading(handleAbove, loadedPages)
  useEffect(() => {
    setisLoaded(arePagesLoaded)
  }, [arePagesLoaded, gameInfo.user_id, setisLoaded])

  const [setStatus, doMessage, sendSocketMessage] = useSocketMessages({
    socket,
    MessagesList,
    setbetInfo,
    setgameInfo,
    addInHistory,
    setSeeds,
    handleErrorText,
    receiveSettings,
    handleNotification,
    setBetReply,
    setErrorCode,
  })
  if (!socket.current) {
    createSocket(socket, doMessage, setStatus, WS_URL, name, wsbridge)
  }

  const sendBet = useCallback(
    (bet: string | number) => {
      if (stakeChecker(bet, maxBet, minBet, balance, handleNotification)) {
        sendSocketMessage(
          Protocol.BET_POST,
          +bankerStake,
          +tieStake,
          +playerStake,
        )
        sendSettings([bankerStake, tieStake, playerStake], audio)
      }
    },

    [maxBet, minBet, balance, handleNotification, sendSocketMessage],
  )
  const requestBetReply = (id: string) => {
    sendSocketMessage(Protocol.GET_ROUND, id)
  }

  const SFXS = useGlobalAudio(audio.volume, audio.sound)
  const AUDIO = useCustomAudio(audio.volume, audio.sound)

  const [showResult, setShowResult] = useState<boolean>(false)
  const handleUpdateBalance = (r: boolean) => setShowResult(r)

  const { finalBalance } = useBalanceUpdate(betInfo, showResult, balance)

  const [playBackgroundSFX, { stop, sound }] = useSound(backgroundSFX, {
    volume: parseFloat(audio.volume),
  })

  useEffect(() => {
    audio.music && errorText === false && isLoaded
      ? (() => {
          playBackgroundSFX()
          sound.loop(true)
        })()
      : stop()
  }, [audio.music, playBackgroundSFX, stop, sound, errorText, isLoaded])

  return (
    <AppContainer color={colors.primary}>
      <GlobalStyle />
      <div className='game-wrapper'>
        <Main blur={blur} modalFadeIn={fadeIn}>
          <Header
            title='BACR'
            gameInfo={gameInfo}
            handleAbove={handleAbove}
            colors={colors}
            sfx={SFXS.goForwardSFX}
            fontSize='20px'
            betInfoBalance={finalBalance}
            balanceUpdateOn={balanceUpdateOn}
          />
          <Baccarat
            stake={stake}
            bankerStake={bankerStake}
            playerStake={playerStake}
            tieStake={tieStake}
            handleStake={handleStake}
            handlePlayerStake={handlePlayerStake}
            handleBankerStake={handleBankerStake}
            handleTieStake={handleTieStake}
            handleAbove={handleModal}
            SFXS={AUDIO}
            handleNotification={handleNotification}
            gameInfo={gameInfo}
            sendSettings={sendSettings}
            sendSocketMessage={sendSocketMessage}
            sendBet={sendBet}
            fixedTotalStake={totalStakeAmount}
            handleCurrentStake={handleCurrentStake}
            handleCurrentName={handleCurrentName}
            handleFinalStake={handleFinalStake}
            currentName={currentName}
            betInfo={betInfo}
            isZero={isZero}
            handleUpdateBalance={handleUpdateBalance}
            audio={audio}
            isError={isError}
            finalBalance={finalBalance}
          />
        </Main>
        {modal === "SetStake" && (
          <>
            <SetStakeModalPage
              colors={colors}
              balance={finalBalance}
              gameInfo={gameInfo}
              stake={currentStake}
              handleStake={handleStake}
              handleNotification={handleNotification}
              audio={audio}
              isZero={isZero}
              SFX={SFXS}
              handleModal={handleModal}
              fadeOut={fadeOut}
            />
          </>
        )}
      </div>
      {above === "settings" &&
        Page({
          name: "settings",
          unBlur: settingsUnblur,
          handleAudio,
        })}
      {above === "Game Rules" && Page({ name: "Game Rules" })}
      {above === "Provably Fair" &&
        Page({
          name: "Provably Fair",
          seeds,
          seedRequest,
          newSeedRequest,
          handleNotification,
          audio,
          verifierFunc,
        })}
      {above === "History" &&
        Page({
          name: "History",
          unBlur,
          history,
          user_id,
          toFix: precision,
          handleNotification,
          requestBetReply,
          setRoundId,
          audio,
          payout: true,
        })}
      {above === "Bet Reply" &&
        Page({
          name: "Bet Reply",
          handleNotification,
          betReplyResponse: betReply,
          roundId,
          audio,
          toFix: precision,
          gameInfo: { gameInfo },
          betInfo: betInfoBox,
          headerpadding: "0 30px",
        })}
      {!!errorText && <Error text={errorText} unBlur={false} audio={audio} />}
      {!isLoaded && !enableLoading && <Loading duration={duration} />}
      {!!notification && (
        <Notification
          colors={colors}
          fadeOut={notificationfadeOut}
          handleNotification={handleNotification}
          text={notification}
          unBlur={unBlur}
          audio={audio}
        />
      )}
    </AppContainer>
  )
}
export default App
